var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActive),expression:"isActive"}],staticClass:"tab-content-wrapper",attrs:{"aria-hidden":!_vm.isActive,"id":_vm.id,"fx":"","fx1":""}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }